/*
 *
 * CollaboratorsImport constants
 *
 */

export const GET_TEMPLATE_COLLABORATORS_WATCHER =
  "app/CollaboratorsImport/GET_TEMPLATE_COLLABORATORS_WATCHER"
export const GET_TEMPLATE_COLLABORATORS_SUCCESS =
  "app/CollaboratorsImport/GET_TEMPLATE_COLLABORATORS_SUCCESS"
export const GET_TEMPLATE_COLLABORATORS_FAILED =
  "app/CollaboratorsImport/GET_TEMPLATE_COLLABORATORS_FAILED"

export const UPLOAD_TEMPLATE_COLLABORATORS_WATCHER =
  "app/CollaboratorsImport/UPLOAD_TEMPLATE_COLLABORATORS_WATCHER"
export const UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS =
  "app/CollaboratorsImport/UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS"
export const UPLOAD_TEMPLATE_COLLABORATORS_FAILED =
  "app/CollaboratorsImport/UPLOAD_TEMPLATE_COLLABORATORS_FAILED"

export const GET_TEMPLATE_CEASED_WATCHER =
  "app/CollaboratorsImport/GET_TEMPLATE_CEASED_WATCHER"
export const GET_TEMPLATE_CEASED_SUCCESS =
  "app/CollaboratorsImport/GET_TEMPLATE_CEASED_SUCCESS"
export const GET_TEMPLATE_CEASED_FAILED =
  "app/CollaboratorsImport/GET_TEMPLATE_CEASED_FAILED"

export const GET_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER = "app/CollaboratorsImport/GET_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER"
export const GET_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS = "app/CollaboratorsImport/GET_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS"
export const GET_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED = "app/CollaboratorsImport/GET_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED"
export const GET_TEMPLATE_TEAMS_WATCHER =
  "app/CollaboratorsImport/GET_TEMPLATE_TEAMS_WATCHER"
export const GET_TEMPLATE_TEAMS_SUCCESS =
  "app/CollaboratorsImport/GET_TEMPLATE_TEAMS_SUCCESS"
export const GET_TEMPLATE_TEAMS_FAILED =
  "app/CollaboratorsImport/GET_TEMPLATE_TEAMS_FAILED"

export const UPLOAD_TEMPLATE_CEASED_WATCHER =
  "app/CollaboratorsImport/UPLOAD_TEMPLATE_CEASED_WATCHER"
export const UPLOAD_TEMPLATE_CEASED_SUCCESS =
  "app/CollaboratorsImport/UPLOAD_TEMPLATE_CEASED_SUCCESS"
export const UPLOAD_TEMPLATE_CEASED_FAILED =
  "app/CollaboratorsImport/UPLOAD_TEMPLATE_CEASED_FAILED"

export const UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER = "app/CollaboratorsImport/UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER"
export const UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS = "app/CollaboratorsImport/UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS"
export const UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED = "app/CollaboratorsImport/UPLOAD_TEMPALTE_DIVISIONS_ASSIGNMENT_FAILED"

  
export const UPLOAD_TEMPLATE_TEAMS_WATCHER =
"app/CollaboratorsImport/UPLOAD_TEMPLATE_TEAMS_WATCHER"
export const UPLOAD_TEMPLATE_TEAMS_SUCCESS =
"app/CollaboratorsImport/UPLOAD_TEMPLATE_TEAMS_SUCCESS"
export const UPLOAD_TEMPLATE_TEAMS_FAILED =
"app/CollaboratorsImport/UPLOAD_TEMPLATE_TEAMS_FAILED"
